import { createAction } from '@reduxjs/toolkit'
import { AppState } from '../../appState'

export const setBalanceVisibility = createAction<boolean>(
  'common/setBalanceVisibility',
)

export const setBalanceVisibilityReducer = (
  state: AppState['common'],
  action: ReturnType<typeof setBalanceVisibility>,
): void => {
  state.isBalanceVisible = action.payload
}
